import { axios } from "@/lib/axios";
import { MutationConfig } from "@/lib/react-query";
import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";
import { Notification } from "../types";

export type UpdateNotificationDTO = {
  data: {
    readAt: string;
  };
  leadId: string | number | undefined;
};

const updateNotification = async ({
  leadId,
  data,
}: UpdateNotificationDTO): Promise<Notification> => {
  if (!leadId) {
    Promise.reject();
  }
  return await axios.patch(`/chatMessages/${leadId}/notifications`, data);
};

type UseUpdateNotificationOptions = {
  config?: MutationConfig<typeof updateNotification>;
};

export const useUpdateNotification = ({
  config,
}: UseUpdateNotificationOptions = {}) => {
  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateNotification,
    onError: (error) => {
      const message = error.response?.data?.message || error.message;
      enqueueSnackbar(message, { variant: "error" });
    },
    onSettled: () => {
      return queryClient.invalidateQueries(["notifications"]);
    },
    ...config,
  });
};
